import { useMemo } from 'react';
import { getUser } from '../utils/persist';
import { ROLES } from '../utils/constants';

const handleRedirect = () => {
  const user = getUser();
  const currentUrl = window.location.href;

  if (!user) {
    if (process.env.NODE_ENV === 'development') {
      window.alert(
        "MODALITÀ DEV:\nUtilizzare l'applicazione login per generare un token.",
      );
      return false;
    }

    window.location.href = `/login?redirectTo=${currentUrl}`;
    return false;
  }

  // check token validity date
  if (user.exp * 1000 < Date.now()) {
    window.location.href = `/login?redirectTo=${currentUrl}`;
    return false;
  }

  // check role
  if (!user.roles.includes(ROLES.USER_MANAGER)) {
    window.location.href = '/login';
    return false;
  }

  return true;
};

const AuthController = ({ children }) => {
  const showContent = useMemo(handleRedirect, []);

  if (showContent) {
    return children;
  }

  return null;
};

export default AuthController;
